import {AnnualInspectionType} from "@/models/Enums";

export default class AddAnnualInspectionTypeMappingRequest {

    public annualInspectionType: AnnualInspectionType = AnnualInspectionType.Inspection;

    public productGroupId: string | null = null;
}